import z from "zod";

export const passwordChangeSchema = z
  .object({
    current_password: z.string().min(1, "기존 비밀번호를 입력해주세요."),
    new_password: z.string().min(1, "새 비밀번호를 입력해주세요."),
    confirm_password: z.string().min(1, "새 비밀번호 확인을 입력해주세요."),
  })
  .refine((data) => data.new_password === data.confirm_password, {
    message: "비밀번호가 일치하지 않습니다.",
    path: ["confirm_password"],
  })
  .refine(
    (data) => {
      const hasUpper = /[A-Z]/.test(data.new_password);
      const hasLower = /[a-z]/.test(data.new_password);
      const hasNumber = /[0-9]/.test(data.new_password);
      const hasSpecial = /[!@#$%^&*]/.test(data.new_password);
      return hasUpper && hasLower && hasNumber && hasSpecial;
    },
    {
      message: "비밀번호는 8~16자, 영대소문자/숫자/특수문자 중 2가지 이상 조합",
      path: ["new_password"],
    }
  );
